import React from 'react';
import MassEditModal from '../mass-edit-modal';
import { Form } from 'react-bootstrap';
import { useEditor } from '../mass-edit-modals';

export default () => {
    const editor = useEditor({
        getInitialValue: ({ description }) => ({ description })
    })

    return (
        <MassEditModal
            title={`Edit ${editor.experiences.length} Descriptions`}
            onCancel={editor.onClose}
            onSave={editor.save}
            busy={editor.isBusy}
        >
            <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control
                    type="text"
                    value={editor.value.description}
                    onChange={e => editor.setValue({ description: e.target.value})}
                />
            </Form.Group>
        </MassEditModal>
    );
};
